module.exports = __webpack_public_path__ + "img/logo.4760e00f.png";